"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _routes = require("../routing/routes.js");

var MenuLink = function MenuLink(props) {
  var children = props.children,
      activeClassName = props.activeClassName,
      pageName = props.pageName,
      url = props.url;
  var className = (0, _classnames["default"])("menu-link", props.className);
  return pageName ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    className: className,
    activeClassName: activeClassName,
    to: _routes.Cms.location({
      pageName: pageName
    })
  }, children) : /*#__PURE__*/_react["default"].createElement("a", {
    className: className,
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};

exports.MenuLink = MenuLink;
MenuLink.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  activeClassName: _propTypes["default"].string,
  pageName: _propTypes["default"].string,
  url: _propTypes["default"].string
};